const bundlePermissions = (action, permissions, institutionId) => {
  if (
    action === ('bundle:viewManifest' || 'bundle:viewBundle') &&
    permissions[institutionId].includes(`DATAPOINTS_INSTITUTION`)
  ) {
    return true;
  }

  if (
    action.startsWith('bundle:') &&
    permissions[institutionId].some((item) =>
      [`DATAPOINTS_DEVELOPER`, `THE_STAFF_ACCESS_ALL_INSTITUTIONS`].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  bundlePermissions,
};
